const locale = {
  'c.ApplyAccount.title': '申请开通账号',

  'c.ApplyAccount.label.countryCode': '国家',
  'c.ApplyAccount.label.companyName': '你的公司名称',
  'c.ApplyAccount.label.userName': '你的名字',
  'c.ApplyAccount.label.contactInformation': '你的手机号或邮箱地址',
  'c.ApplyAccount.label.remark': '你想通过casschoice解决什么问题？',

  'c.ApplyAccount.placeholder.pleaseSelect': '请选择',
  'c.ApplyAccount.placeholder.pleaseEnter': '请输入',
  'c.ApplyAccount.placeholder.contactInformation': '请输入WhatsApp或邮箱地址',

  'c.ApplyAccount.button.submit': '注册',
  'c.ApplyAccount.text.disclaimerText': '我已阅读且同意 {serviceAgreement} 和 {privacyPolicy}',
  'c.ApplyAccount.text.agreeTextMessage': '我同意接收短信通知',
  'c.ApplyAccount.text.notice':
    '我们将在收到申请的3个工作日内处理，并通过邮件或WhatsApp联系你，请注意查收。',

  'c.ApplyAccount.disclaimerText.error': '请先阅读并同意协议',
  'c.ApplyAccount.agreeTextMessage.error': '请先同意接收短信通知',

  'c.ApplyAccount.request.loading': '提交中...',
  'c.ApplyAccount.request.success': '提交成功，我们将在3个工作日内完成你的注册申请',
  'c.ApplyAccount.request.error': '提交失败！请稍后重试。',
};
export default locale;
